export class ExternalTemplateCopyResult {
  isComplete: boolean;
  copiedId: string;
}
